// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tableRow":"_2dATcB_Btni9u24kDFh2mj"};